export default function changesToContent(changes) {
  let content = '';

  changes.map((change) => {
    content += change + '\n\n';
  });

  return content;
}
